import { Mutation } from 'vuex'
import { Field } from '@/types/action'
import nestedFreeze from '@/helpers/nestedFreeze'
import { ArticleState } from '../types'

const setArticleField: Mutation<ArticleState> = (
  state,
  { key, value }: { key: 'types'; value: Record<string, Field> }
) => {
  state.fields[key] = nestedFreeze(value)
}

export default setArticleField
